export function hexToHSL(hex: string) {
  let r = 0,
    g = 0,
    b = 0;

  if (hex.length === 4) {
    r = parseInt(hex[1] + hex[1], 16);
    g = parseInt(hex[2] + hex[2], 16);
    b = parseInt(hex[3] + hex[3], 16);
  } else {
    r = parseInt(hex[1] + hex[2], 16);
    g = parseInt(hex[3] + hex[4], 16);
    b = parseInt(hex[5] + hex[6], 16);
  }

  r /= 255;
  g /= 255;
  b /= 255;
  const max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  let h = 0,
    s = 0,
    l = (max + min) / 2;

  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }

  return {
    h: Math.round(h * 360),
    s: Math.round(s * 100),
    l: Math.round(l * 100),
  };
}

export function clampSaturation(hsl: any, min = 20, max = 80) {
  return { ...hsl, s: Math.min(max, Math.max(min, hsl.s)) };
}

export function clampLightness(hsl: any, min = 20, max = 85) {
  return { ...hsl, l: Math.min(max, Math.max(min, hsl.l)) };
}

export function adjustLightness(hsl: any, amount: any) {
  return { ...hsl, l: Math.min(100, Math.max(0, hsl.l + amount)) };
}

export function adjustSaturation(hsl: any, amount: any) {
  return { ...hsl, s: Math.min(100, Math.max(0, hsl.s + amount)) };
}

export function hslToCSS(hsl: any) {
  return `${hsl.h} ${hsl.s}% ${hsl.l}%`;
}

export function getForegroundFor(hsl: any) {
  return hsl.l < 50 ? "0 0% 100%" : "171 100% 11%";
}
